// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"adc34edb","911":"45478813"}[chunkId] + ".chunk.js";
};